import { ROUTES } from "@/shared/routing/routes"

const ELIGIBLE_ROUTES = [
  ROUTES.coverage.path,
  ROUTES.tribeQuote.path,
  ROUTES.healthCoverageParam.path,
  ROUTES.userInformations.path,
  ROUTES.userAddress.path,
  ROUTES.userBirthInformations.path,
  ROUTES.recap.path,
]

export function isSendMyQuoteEligible(pathname: string): boolean {
  return (
    ELIGIBLE_ROUTES.some((route) => pathname.includes(route)) &&
    !pathname.includes(ROUTES.payment.path)
  )
}
